import { lazy, Suspense } from 'react'
import { createBrowserRouter, Navigate, useParams } from 'react-router-dom'
import AppShell from './components/layout/AppShell'
import ScrollToTop from './components/ScrollToTop'

const L = (factory) => {
  const C = lazy(factory)
  return (
    <Suspense fallback={<div className="p-10 text-sm text-ink-3">Loading…</div>}>
      <ScrollToTop />
      <C />
    </Suspense>
  )
}
function RedirectAccount() { const { id } = useParams(); return <Navigate to={`/app/accounts/${id}`} replace /> }

export const router = createBrowserRouter([
  // Marketing site
  { path: '/', element: L(() => import('./pages/public/Landing')) },
  { path: '/features', element: L(() => import('./pages/public/Features')) },
  { path: '/templates', element: L(() => import('./pages/public/Templates')) },
  { path: '/pricing', element: L(() => import('./pages/public/Pricing')) },
  { path: '/docs', element: L(() => import('./pages/public/Docs')) },
  { path: '/privacy', element: L(() => import('./pages/public/Privacy')) },
  { path: '/terms', element: L(() => import('./pages/public/Terms')) },

  // Auth
  { path: '/login', element: L(() => import('./pages/auth/Login')) },
  { path: '/signup', element: L(() => import('./pages/auth/Signup')) },
  { path: '/forgot-password', element: L(() => import('./pages/auth/ForgotPassword')) },
  { path: '/reset-password', element: L(() => import('./pages/auth/ResetPassword')) },

  // App
  {
    path: '/app',
    element: <AppShell />,
    children: [
      { index: true, element: L(() => import('./pages/app/Dashboard')) },
      { path: 'popups', element: L(() => import('./pages/app/Popups')) },
      { path: 'popups/new', element: L(() => import('./pages/app/NewPopup')) },
      { path: 'popups/:id', element: L(() => import('./pages/app/PopupEditor')) },
      { path: 'popups/:id/report', element: L(() => import('./pages/app/PopupReport')) },
      { path: 'analytics', element: <Navigate to="/app/analytics/funnel" replace /> },
      { path: 'analytics/funnel', element: L(() => import('./pages/app/analytics/Funnel')) },
      { path: 'analytics/attribution', element: L(() => import('./pages/app/analytics/Attribution')) },
      { path: 'analytics/quality', element: L(() => import('./pages/app/analytics/Quality')) },
      { path: 'analytics/sources', element: L(() => import('./pages/app/analytics/Sources')) },
      { path: 'analytics/journeys', element: L(() => import('./pages/app/analytics/Journeys')) },
      { path: 'analytics/journeys/:visitorId', element: L(() => import('./pages/app/analytics/Journeys')) },
      { path: 'analytics/ask', element: L(() => import('./pages/app/analytics/Ask')) },
      { path: 'insights', element: L(() => import('./pages/app/Insights')) },
      { path: 'subscribers', element: L(() => import('./pages/app/Submissions')) },
      { path: 'submissions', element: <Navigate to="/app/subscribers" replace /> },
      { path: 'accounts', element: L(() => import('./pages/app/Sites')) },
      { path: 'accounts/:id', element: L(() => import('./pages/app/SiteDetail')) },
      { path: 'sites', element: <Navigate to="/app/accounts" replace /> },
      { path: 'sites/:id', element: <RedirectAccount /> },
      { path: 'assets', element: L(() => import('./pages/app/Assets')) },
      { path: 'developers', element: L(() => import('./pages/app/Developers')) },
      { path: 'settings', element: L(() => import('./pages/app/Settings')) },
    ],
  },
  { path: '*', element: <Navigate to="/" replace /> },
])
